import { PwaNotice, PwaNoticeView, noticeItems } from "@mops/pwa-v1/react";
import type { PwaNoticeText } from "@mops/pwa-v1/react";
import { Icon } from "./Icon";
import { API } from "../lib/tasks";
import { tx } from "../i18n";

/* ══ PWA 안내의 자리 — 새 버전 대기 · 서버 연결 안 됨(docs/decisions/pwa.md) ══
   **판정과 모양은 공통 `@mops/pwa-v1` 그대로**다(사람이 눌러야만 새로고침 · fetch 거부일 때만 「안 닿음」 ·
   v3 `.b-toasts`). 여기는 이 앱의 문장(사전) · 아이콘 · 건강 확인 주소만 넘긴다 — 판정을 b3x-in 에
   다시 만들지 않는다(사본이 생기는 길이다, Totp.tsx 와 같은 결). */

/** 문장은 사전에서 꺼낸다 — 단추는 공통 낱말(common.action.*)이다. */
function pwaText(): PwaNoticeText {
  return {
    update: tx("pwa.update"),
    unreachable: tx("pwa.unreachable"),
    refresh: tx("common.action.refresh"),
    retry: tx("common.action.retry"),
  };
}

const ICONS = { info: <Icon name="info" />, warning: <Icon name="alert" /> };

/** 앱 루트 한 곳(App.tsx)에 선다 — 로그인 문지기 **밖**이다(로그인 화면에서도 말해야 한다).
 *  건강 확인은 nginx 가 api 로 넘기는 `/api/health` — 「안 닿음」은 그 요청이 **거부**될 때만이다. */
export function AppPwaNotice() {
  return <PwaNotice healthUrl={`${API}/health`} text={pwaText()} icons={ICONS} />;
}

/** 패턴 페이지 견본 — 실물 `PwaNotice` 는 SW · 서버 상태에 묶여 상태를 골라 세울 수 없다.
 *  그래서 **어느 안내가 뜨는지는 공통 `noticeItems`**, **모양은 공통 `PwaNoticeView`** 가 정한다 — 마크업을 여기
 *  다시 적지 않는다. 자리는 패턴 페이지가 정하므로 `.b-toasts` 틀은 뺀다(`stack: false`). */
export function PwaNoticeSample({ updateWaiting, reachable, checking }: { updateWaiting: boolean; reachable: boolean | null; checking?: boolean }) {
  return <PwaNoticeView items={noticeItems({ updateWaiting, reachable }, pwaText())} icons={ICONS} checking={checking} stack={false} />;
}
